"use strict";

export default class FormConfirmDelete {
    constructor() {
        let self = this;

        $("form.confirm-delete").off().on("submit", function() {
            let _this = this;
            self.showDeleteConfirmationModal(this, function() {
                _this.submit();
            });
            return false;
        });

        $("a.confirm-delete").off().on("click", function() {
            let _this = this;
            self.showDeleteConfirmationModal(this, function() {
                window.location.assign(_this.getAttribute("href"));
            });
            return false;
        });
    }

    showDeleteConfirmationModal(elem, callback) {
        let content = $(elem).attr("data-content");
        let dialog = new Dialog();
        dialog.confirm("Confirm Delete", content ? content : "Are you sure you want to delete this item?", callback);
    }
}
